module.exports = "/_next/static/images/video_id_7179318074703678762-dcbff363a34163442d7b8c4dd1acc148.jpg";